'use client';

import { useCallback } from 'react';
import { IsolatedFixedWorkspaceIdContextProvider } from '@frameio/shared/contexts';
import { useWatermarkModalContext } from '@frameio/shared/contexts/ModalContext';
import { WatermarkTemplateManagerDialog } from './templates/WatermarkTemplateManagerDialog';

export const WatermarkSelectionDialog = () => {
  const {
    activeTemplateId,
    canManageTemplates,
    close,
    dialogHeader,
    isOpen,
    onTemplateSelect,
    workspaceId,
  } = useWatermarkModalContext();

  const handleTemplateSelect = useCallback(
    (template: { id: string; name: string }) => {
      onTemplateSelect(template);
      close();
    },
    [close, onTemplateSelect]
  );

  /**
   * The dialog is mounted at the app root, so it inherits the active project
   * (and account) context from `ActiveProjectIdFromParams` in the layout.
   * Workspace has no equivalent auto-provider, so when an opener supplies a
   * `workspaceId` via the modal payload we wrap the dialog tree with a
   * workspace context provider so `useWatermarkTemplates` resolves to the
   * workspace scope.
   */
  const dialog = (
    <WatermarkTemplateManagerDialog
      canManageTemplates={canManageTemplates}
      data-testid="watermark-template-selection-modal"
      dialogHeader={dialogHeader}
      isShowing={isOpen}
      onRequestClose={close}
      onTemplateSelect={handleTemplateSelect}
      selectedTemplateId={activeTemplateId}
    />
  );

  if (workspaceId) {
    return (
      <IsolatedFixedWorkspaceIdContextProvider workspaceId={workspaceId}>
        {dialog}
      </IsolatedFixedWorkspaceIdContextProvider>
    );
  }

  return dialog;
};
